module.exports = __webpack_public_path__ + "img/hero-section.ad2ec7ec.svg";